/**
 * Cookie utility functions for client-side cookie management
 */

interface SetCookieOptions {
  maxAge?: number;
  path?: string;
  sameSite?: "Strict" | "Lax" | "None";
  secure?: boolean;
}

/**
 * Sets a cookie with the given name, value, and options
 */
export function setCookie(
  name: string,
  value: string,
  options: SetCookieOptions = {},
): void {
  if (typeof document === "undefined") {
    return;
  }

  const { maxAge, path = "/", sameSite = "Lax", secure = false } = options;

  let cookieString = `${name}=${encodeURIComponent(value)}`;

  if (path) {
    cookieString += `; path=${path}`;
  }

  if (maxAge !== undefined) {
    cookieString += `; max-age=${maxAge}`;
  }

  if (sameSite) {
    cookieString += `; SameSite=${sameSite}`;
  }

  if (secure) {
    cookieString += "; secure";
  }

  // biome-ignore lint: document.cookie is the only browser API for setting cookies
  document.cookie = cookieString;
}

/**
 * Removes a cookie by setting it to expire immediately
 */
export function removeCookie(name: string, path = "/"): void {
  if (typeof document === "undefined") {
    return;
  }

  // biome-ignore lint: document.cookie is the only browser API for setting cookies
  document.cookie = `${name}=; path=${path}; max-age=0`;
}
